import {
  TestimonialCarousel as TestimonialCarouselZDS,
  TestimonialCarouselProps,
  TestimonialSoloProps,
  Img,
} from '@zapier/design-system';
import { RichTextHtml } from '../../RichTextHtml/RichTextHtml';
import { RichTextHTMLString } from '../types';
import { DEFAULT_VALUES } from './fixtures';

type Testimonials = Array<
  Omit<TestimonialSoloProps, 'backgroundColor'> & {
    mediaURL: string;
    mediaAltText: string;
  }
>;

export type Props = Omit<TestimonialCarouselProps, 'testimonials'> & {
  testimonials: Testimonials;
};

export function TestimonialCarousel({
  backgroundColor,
  testimonials = [],
}: Props) {
  return (
    <TestimonialCarouselZDS
      backgroundColor={backgroundColor || DEFAULT_VALUES.backgroundColor}
      testimonials={testimonials.map((testimonial) => {
        return {
          ...testimonial,
          quote: (
            <RichTextHtml html={testimonial.quote as RichTextHTMLString} />
          ),
          mediaElement: (
            <Img
              src={testimonial.mediaURL || ''}
              alt={testimonial.mediaAltText || ''}
            />
          ),
          // Implementing without video until we can figure out a better solution for our video player
        };
      })}
    />
  );
}
